import { gql } from "graphql-request";

/**
 * The fields every image selection needs.
 *
 * In its own module for the same reason as `LINK_FIELDS`: four owners' queries
 * import it, and putting it beside one owner's query would make that owner look
 * special when it is not.
 *
 * No `sortOrder`: the server returns the list already ordered.
 */
export const IMAGE_FIELDS = gql`
  fragment ImageFields on Image {
    id
    url
    thumbnailUrl
    altText
    credit
    width
    height
    isPrimary
  }
`;
